import * as types from "./actionTypes";

export const setCarltonForestReadingLoading = (isLoading) => {
  return {
    type: types.SET_CARLTON_FOREST_READING_LOADING,
    payload: isLoading,
  };
};

export const markDocumentReadCarltonForest = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_CARLTON_FOREST,
  payload: documentFilename,
});

export const setInductionFormCarltonForestLoading = (isLoading) => ({
  type: types.SET_INDUCTION_FORM_CARLTON_FOREST_LOADING,
  payload: isLoading,
});

export const setInductionFormItemCarltonForestLoading = (isLoading) => ({
  type: types.SET_INDUCTION_FORM_ITEM_CARLTON_FOREST_LOADING,
  payload: isLoading,
});

export const postSSOWCarltonForest = (formName, formContent) => ({
  type: types.POST_SSOW_CARLTON_FOREST,
  payload: { formName, formContent },
});

export const setSSOWCarltonForestLoading = (formName) => {
  return {
    type: types.SET_SSOW_CARLTON_FOREST_LOADING,
    payload: formName,
  };
};
export const setSSOWItemsCarltonForestLoading = (isLoading) => {
  return {
    type: types.SET_SSOW_ITEMS_CARLTON_FOREST_LOADING,
    payload: isLoading,
  };
};

export const postCarltonForestForm = (formName, formContent) => ({
  type: types.POST_CARLTON_FOREST_FORMS,
  payload: { formName, formContent },
});

export const submitCarltonForestForm = (formName, formContent, typeCode) => ({
  type: types.SUBMIT_CARLTON_FOREST_FORMS,
  payload: { formName, formContent, typeCode },
});
